module.exports = __webpack_public_path__ + "img/img21.efeca4c2.png";